import { createWebHashHistory, createRouter } from 'vue-router'

import PlayCharacter from '@/views/PlayCharacter'
import CreateCharacter from '@/views/CreateCharacter'
import ListCharacters from '@/views/ListCharacters'
import Room from '@/views/Room'
import ViewCharacter from '@/views/ViewCharacter'
import Home from '@/views/Home'

const routes = [
  // Characters
  {
    path: '/characters/create',
    name: 'createCharacter',
    component: CreateCharacter, 
    meta: { 
      readOnly: true,
      fluidContainer: true
    }
  },
  {
    path: '/characters/play/:id',
    name: 'playCharacter',
    component: PlayCharacter, 
    meta: { 
      fluidContainer: true
    }
  },
  {
    path: '/characters/play',
    redirect: 'listCharacters'
  },
  {
    path: '/characters',
    name: 'listCharacters',
    component: ListCharacters
  },

  // Room
  {
    path: '/room/characters/:id',
    name: 'viewCharacter',
    component: ViewCharacter, 
    meta: { 
      readOnly: true,
      fluidContainer: true
    }
  },
  {
    path: '/room/characters',
    redirect: 'room'
  },
  {
    path: '/room',
    name: 'room',
    component: Room, 
    meta: { 
      fluidContainer: true
    }
  },

  // Other
  {
    path: '/',
    name: 'home',
    component: Home
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
